import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate,  useLocation } from 'react-router-dom';
import InputMask from 'react-input-mask';
import ClipLoader from 'react-spinners/ClipLoader';
import './FormPage.css'; 

const FormPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [referralNumber, setReferralNumber] = useState('');
    const [ip, setIp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    
useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        setIp(response.data.ip);
      } catch (error) {
        setIp('');
      }
    };

    fetchIp();

    const searchParams = new URLSearchParams(location.search);
    const referral = searchParams.get('r');
    if (referral && /^\d{11}$/.test(referral)) {
      setReferralNumber(referral);
    } else {
      navigate('/error');
    }
  }, [location.search, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Verificar o timestamp do último envio baseado no IP
    const lastSubmissionTime = localStorage.getItem(`lastSubmissionTime_${ip}`);
    if (lastSubmissionTime) {
      const now = new Date().getTime();
      const oneHour = 30 * 1000 //60 * 60 * 1000;
      if (now - lastSubmissionTime < oneHour) {
        navigate('/error-time');
        return; // Impede o envio do formulário
      }
    }

    const unmaskedWhatsapp = whatsapp.replace(/\D/g, ''); // Remove a máscara, deixando apenas os números

    setIsLoading(true);

    try {
      const response = await axios.post('https://consumer-referral-integration.lambda.multipedidos.com.br', {
        name,
        email,
        businessName,
        phone: unmaskedWhatsapp,
        referralPhone: referralNumber
      });
      if (response.status === 200) {
        // Armazenar o timestamp do envio usando o IP como parte da chave
        localStorage.setItem(`lastSubmissionTime_${ip}`, new Date().getTime());
        navigate('/thank-you');
      }
    } catch (error) {
      alert('Ocorreu um erro ao enviar o formulário. Tente novamente.');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="form-container">

        <section>
            <img src='/mp-logo.png' alt='Logo Multipedidos' width='200px'/>
            <h1>Você Recebeu um Convite para Conhecer a <span style={{color: "orangered"}}>Melhor Plataforma</span> Para a Gestão do Seu Delivery</h1>
            <h3>Através deste link, você ganhou 100% de desconto na taxa de implantação na plataforma mais completa do Brasil para impulsionar o seu delivery com <span style={{color: "orangered"}}>agilidade e praticidade</span></h3>
            <p>Informe seus dados abaixo e entraremos em contato</p>
        </section>

        <section>
            <form onSubmit={handleSubmit} className="form">
                <div className="form-group">
                <label>Seu nome *</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                </div>
                <div className="form-group">
                <label>Seu e-mail *</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                </div>
                <div className="form-group">
                <label>Nome do Seu Estabelecimento *</label>
                <input
                    type="text"
                    value={businessName}
                    onChange={(e) => setBusinessName(e.target.value)}
                    required
                />
                </div>
                <div className="form-group">
                <label>Seu WhatsApp com DDD *</label>
                <InputMask
                    mask="(99) 99999-9999"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    required
                >
                    {(inputProps) => <input {...inputProps} type="text" />}
                </InputMask>
                </div>
                <button type="submit" className="submit-button" disabled={isLoading} >
                    {isLoading ? <ClipLoader color="#fff" size={20} /> : 'Enviar'}
                </button>
            </form>
        </section>

        <section>
            <h3>Benefícios da Plataforma Pedir.Delivery, da Multipedidos</h3>
            <img src='/beneficios-pedir-delivery.png' alt='Benefícos Pedir Delivery' width='100%' style={{maxWidth: '500px'}}/>
        </section>

        <section>
            <h3>Conheça mais nossas funcionalidades</h3>
            <div className="features-container">
                <div className="feature-block">
                    <img src="cardapio-digital.png" alt="Cardápio Digital Interativo" />
                    <h2>Cardápio Digital Interativo</h2>
                    <p>Receba todos os pedidos através de um cardápio digital totalmente personalizado.</p>
                </div>
                <div className="feature-block">
                    <img src="gestor.png" alt="Gestor de Pedidos Integrado" />
                    <h2>Gestor de Pedidos Integrado</h2>
                    <p>Controle o fluxo de pedidos. Aceite, recuse ou altere-os. Tenha uma visão geral e completa das compras.</p>
                </div>
                <div className="feature-block">
                    <img src="cupom.png" alt="Cupom de Desconto, Programa Fidelidade e Sorteios" />
                    <h2>Cupom de Desconto, Programa Fidelidade e Sorteios</h2>
                    <p>Diversas ferramentas de marketing para aumentar ainda mais suas vendas.</p>
                </div>
                <div className="feature-block">
                    <img src="relatorio.png" alt="Relatório de Vendas, Clientes e Produtos" />
                    <h2>Relatório de Vendas, Clientes e Produtos</h2>
                    <p>Tenha muito mais organização, controle e gestão otimizada do seu delivery.</p>
                </div>
                <div className="feature-block">
                    <img src="integracoes.png" alt="Integrações com Facebook" />
                    <h2>Integrações com Facebook</h2>
                    <p>Integrações simples e eficazes com o Facebook para ampliar suas vendas.</p>
                </div>
                <div className="feature-block">
                    <img src="notificacoes.png" alt="Notificações Push" />
                    <h2>Notificações Push</h2>
                    <p>Mantenha seus clientes atualizados com notificações push.</p>
                </div>
                <div className="feature-block">
                    <img src="avaliacoes.png" alt="Aba de Avaliações" />
                    <h2>Aba de Avaliações</h2>
                    <p>Gerencie e visualize avaliações dos seus clientes em um só lugar.</p>
                </div>
                <div className="feature-block">
                    <img src="suporte.png" alt="Suporte Técnico Todos os Dias" />
                    <h2>Suporte Técnico Todos os Dias</h2>
                    <p>Receba suporte técnico especializado todos os dias.</p>
                </div>
            </div>
        </section>


        <section className='testimonials-section'>
            <h3>Melhor do que ter apenas clientes é quando temos fãs. <span style={{color: 'orangered'}}>#SomosOrangers</span></h3>
            <p style={{textAlign: 'center'}}>Respiramos, comemos, caminhamos e trabalhamos pensando unicamente em como melhorar a experiência dos nossos amados clientes</p>

            <div className='testimonial-container'>

                <div className='testimonial-block'>
                    <img src='dep1.png' alt='Depoimento'/>
                </div>
                <div className='testimonial-block'>
                    <img src='dep2.png' alt='Depoimento'/>
                </div>
                <div className='testimonial-block'>
                    <img src='dep3.png' alt='Depoimento'/>
                </div>
                <div className='testimonial-block'>
                    <img src='dep4.png' alt='Depoimento'/>
                </div>
                <div className='testimonial-block'>
                    <img src='dep5.png' alt='Depoimento'/>
                </div>
                <div className='testimonial-block'>
                    <img src='dep6.png' alt='Depoimento'/>
                </div>

            </div>
        </section>
    </div>
  );
};

export default FormPage;